import { useSelector } from "react-redux";
import { selectState } from "../outputSlice";
import { FormatNumber, FormatNumberWithUnitOrNull } from "utils/numberUtils";
import Loader from "components/Loader/Loader";

const BottomSection = () => {
  const { totalCost: totalPrice, totalQuantityAmount, loading } = useSelector(selectState);

  return (
    <div className="g-grid g-footer">
      {loading && <Loader />}
      <div className="row">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div className="col strong total-quantity danger">
          <span className="bg-item left danger">{FormatNumber(totalQuantityAmount)}</span>
        </div>
        <div className="col strong total-price">
          <span className="bg-item left">{FormatNumberWithUnitOrNull(totalPrice, 'rsd')}</span>
        </div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};
export default BottomSection;
